import { reactive } from "vue";

export const store = reactive<{
	isLogin: boolean;
	isLastStepPage: boolean;
	isLandingPage: boolean;
	landingPage: {
		hasHiResImage: boolean;
		desktopImageURL: string;
		tabletImageURL: string;
		mobileImageURL: string;
		imageAltText: string;
		headerText: string;
	};
	username: string;
	globalErrorMessages: string[];
	httpErrorStatusCode: number | null;
	oAuthSignIn: string;
}>({
	isLogin: true,
	isLastStepPage: false,
	isLandingPage: false,
	landingPage: {
		hasHiResImage: false,
		desktopImageURL: "",
		tabletImageURL: "",
		mobileImageURL: "",
		imageAltText: "",
		headerText: "",
	},
	username: "",
	globalErrorMessages: [],
	httpErrorStatusCode: null,
	oAuthSignIn: "",
});
